import AbstractView from 'abstract'
import Vue from 'vue'
import store from 'definitions/store'
import storeInit from 'initializations/pages/Gallery'
import SidebarInit from 'initializations/Sidebar'

export class Main extends AbstractView {
  constructor(domElementId) {
    return super(domElementId);
  }

  init() {
    SidebarInit.init("sidebar")
    storeInit.init("galleryPage")

    const GalleryPage = () => import(/* webpackChunkName: "gallery-page-single" */ 'containers/Pages/Gallery/Gallery')

    new Vue({
      el: "#" + this.elemId,
      store,
      render: h => h(GalleryPage)
    })
  }
}
